import React from "react";
import { playgroundRules } from "../data/playgroundRules";
import { siteInfo } from "../data/siteInfo";
import Icon from "../components/Icon";
import "../css/RulesandWaiver.css";

export default function RulesAndWaiver() {
  return (
    <div className="before-visit-grid">
      <div className="section-heading">
        <p className="eyebrow">A LITTLE PREP. A LOT OF PLAY.</p>
        <h2>
          First visit?
          <br />
          You’re in the right place.
        </h2>
        <p>
          Sign the waiver before you arrive, pack everyone’s socks, and get
          ready to explore together.
        </p>
        <a
          className="button button-teal"
          href={siteInfo.waiver}
          target="_blank"
          rel="noopener noreferrer"
        >
          Sign the waiver <Icon name="external" />
        </a>
        <p className="form-help">
          Opens our secure Fillout waiver in a new tab.
        </p>
      </div>
      <div className="visit-guidelines">
        <div className="visit-checklist">
          <div>
            <span>01</span>
            <h3>Socks on. Shoes off.</h3>
            <p>Grip socks for children; standard socks for adults.</p>
          </div>
          <div>
            <span>02</span>
            <h3>Stay and play together.</h3>
            <p>A parent or guardian must supervise children at all times.</p>
          </div>
          <div>
            <span>03</span>
            <h3>Save snacks for the table.</h3>
            <p>
              Outside food and drinks are permitted, but must stay out of the
              play areas.
            </p>
          </div>
        </div>
        <details className="all-playground-rules">
          <summary>
            Read all playground rules <span aria-hidden="true">+</span>
          </summary>
          <ul>
            {playgroundRules.map((rule) => (
              <li key={rule}>{rule}</li>
            ))}
          </ul>
        </details>
      </div>
    </div>
  );
}
